module.exports = __webpack_public_path__ + "static/niegolewskich_entire_page-f5f60c436fae0eda4fcf094cc8d03b01.jpg";